import { gql } from '@apollo/client';
import { USER } from '../fragments';

export const ALL_FUNDER_USERS = gql`
  query AllFunderUsers($input: UserFilterInput!) {
    users: allFunderUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...user
          organisations {
            id
            status
            role {
              id
              name
            }
            practitionerType
            organisation {
              id
              isFunder
              funder {
                id
                name
              }
            }
          }
        }
      }
    }
  }
  ${USER}
`;
